import React, { useState, useEffect } from "react";
import {
  Wrapper,
  Container,
  Body,
  Page,
  LinkTag,
  SocialContainer,
  Overlaybg
} from "../styles/Navigation.styles";
import { withRouter } from "react-router";
import NavButton from "./NavButton";

const NavigationMenu = ({ history, hasBackground, setBackground }) => {
  const [isOn, setState] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [linking, setLink] = useState("");

  useEffect(() => {
    !!linking &&
      setTimeout(() => {
        switch (linking) {
          case "home":
            history.push("/");
            setState(false);
            setLink("");
            break;
          case "about":
            history.push("/about");
            setState(false);
            setLink("");
            break;
          case "work":
            history.push("/work");
            setState(false);
            setLink("");
            break;
          case "blog":
            history.push("/blog");
            setState(false);
            setLink("");
            break;
          case "contact":
            history.push("/contact");
            setState(false);
            setLink("");
            break;
          case "services":
              history.push("/services");
              setState(false);
              setLink("");
              break; 
          default:
            setLink("");
        }
        setBackground(false);
        window.scrollTo(0, 0);
      }, 0);
  }, [linking, history, setBackground]);

  useEffect(() => {
    shouldAnimate &&
      !isOn &&
      setTimeout(() => {
        setShouldAnimate(false);
      }, 0);
  }, [shouldAnimate, isOn]);

  const closeHandler = () => {
    setShouldAnimate(true);
    setState(!isOn);
  };

  const setLinkHandler = text => {
    setShouldAnimate(true);
    setLink(text);
  };

  useEffect(() => {
    const header = document.getElementById("header");
    const totop = document.getElementById("scroll-to-top")
    const sticky = header.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
    if (window.pageYOffset > sticky + 0) {
      header.classList.add("sticky");
      totop.classList.add("show");
    } else {
      header.classList.remove("sticky");
      totop.classList.remove("show");
    } 
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
    }, []);

  return (
    <header>
      <div id='header'></div>
      <div className='logo'>
        <img
          src="IconLogoResized.png"
          className="img-fluid"
          alt="#"
        />
        <span className='callus' style={{ color: '#DAA38F' }} >
          Now practicing at: STUDEO GYMS in Vancouver & Beverly Hills
        </span>
      </div>
      <Wrapper open={isOn} shouldAnimate={shouldAnimate}>
        <Overlaybg open={isOn} shouldAnimate={shouldAnimate} onClick={closeHandler}/>
        <Container
          open={isOn}
          onClick={closeHandler}
          hasBackground={hasBackground}>
          <NavButton open={isOn} />
        </Container>
        <Body className='midwrpr' open={isOn} shouldAnimate={shouldAnimate}>
          <div className='conPage'>
              <Page className='mainBtn' variant="home" onClick={() => setLinkHandler("home")}>
                  <LinkTag style={{ color: "#FFB5BA" }}
                   onMouseEnter={(e) => (e.target.style.color = "#92ADA4")}
                   onMouseLeave={(e) => (e.target.style.color = "#FFB5BA")}>Home</LinkTag>
              </Page>
              <Page className='mainBtn' variant="about" onClick={() => setLinkHandler("about")}>
                  <LinkTag style={{ color: "#FFB5BA" }}
                  onMouseEnter={(e) => (e.target.style.color = "#92ADA4")}
                  onMouseLeave={(e) => (e.target.style.color = "#FFB5BA")}>About</LinkTag>
              </Page>
              <Page className='mainBtn' variant="about" onClick={() => setLinkHandler("services")}>
                  <LinkTag style={{ color: "#FFB5BA" }}
                  onMouseEnter={(e) => (e.target.style.color = "#92ADA4")}
                  onMouseLeave={(e) => (e.target.style.color = "#FFB5BA")}>Services</LinkTag>
              </Page>
              <Page className='mainBtn' variant="about" onClick={() => setLinkHandler("blog")}>
                  <LinkTag style={{ color: "#FFB5BA" }}
                  onMouseEnter={(e) => (e.target.style.color = "#92ADA4")}
                  onMouseLeave={(e) => (e.target.style.color = "#FFB5BA")}>WOW Newsletter</LinkTag>
              </Page>
              <Page className='mainBtn' variant="about" onClick={() => setLinkHandler("contact")}>
                  <LinkTag style={{ color: "#FFB5BA" }}
                  onMouseEnter={(e) => (e.target.style.color = "#92ADA4")}
                  onMouseLeave={(e) => (e.target.style.color = "#FFB5BA")}>Contact</LinkTag>
              </Page>
          </div>

          <div className='info' >
            <span style={{ color: "#9B7D61" }}>Have questions?</span>
            <span style={{ color: "#9B7D61" }}>Ready to optimize your health?</span>
            <span className='link'>
              <a href="mailto:drmichellemaliknd@gmail.com">drmichellemaliknd@gmail.com</a>
              </span>
            <span style={{ color: "#9B7D61" }}>Send me an email to get started!</span>
          </div>

          <div>
          <a
  href="https://drmichellendstudeogyms.janeapp.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-block",
    margin: "2rem 0 1rem",
    padding: "0.75rem 1.5rem",
    border: "2px solid #FED8A6",
    color: "#DAA38F",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "bold",
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
  }}
  onMouseOver={(e) => {
    e.target.style.backgroundColor = "#92ADA4";
    e.target.style.color = "#fff";
  }}
  onMouseOut={(e) => {
    e.target.style.backgroundColor = "transparent";
    e.target.style.color = "#DAA38F";
  }}
>
  Book Now
</a>
          </div>

        </Body>
        <SocialContainer className='soc-icon' open={isOn}>
            <span>Follow Me:</span>
            <span className='socicon'><i className="fa fa-linkedin"></i></span>
            <span className='socicon'><i className="fa  fa-instagram"></i></span>
        </SocialContainer>
      </Wrapper>
    </header>
  );
};

export default withRouter(NavigationMenu);
